import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
// import CheckBox from "@material-ui/core/CheckBox";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import InputField from "../../../../../components/common/InputField"
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";
import requestMentor from "../../../../../assets/images/request-mentor.png";
import requestImage from "../../../../../assets/images/tm-1.jpg";
import linewitdot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import dropdownicon from "../../../../../assets/images/arrow.png";
import mentorimage from "../../../../../assets/images/tm-3.jpg";
import orgimage from "../../../../../assets/images/platinum-mentor.png";
import ReactStars from 'react-rating-stars-component';
import "./style.scss";

const firstExample = {
  size: 50,
  count: 5,
  isHalf: false,
  marginTop:-13,
  paddingLeft:25,
  value: 3,
  color: 'gray',
  activeColor: 'orange',
  onChange: (newValue) => {
    
  },
};

const useStyles = makeStyles((theme) => ({
  firstHeading: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.5)",
    fontSize: "18px",
  },
  secondHeading: {
    fontFamily: "Montserrat",
    color: "#6f59a6",
    fontSize: "40px",
    fontWeight: "bold",
  },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "13px",
    // background:
    //   "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(222, 212, 245,0.8130602582830007) 100%)",
  },
 
 
 
  
 
 
 
  mobileMarginForUpperDisplayGrids: {
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  checkboxRoot: {
    color: "#3AC2D7 !important",
  },
}));

// #b499c7
// #3e4a59

const DisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Box className="box-relatedata"  sx={{ position: "relative", width: "100%" }}>
      <Box className={classes.Container}>
        <img
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDot}
        />
      </Box>
      <Box
        style={{
          position: "absolute",
          height: "40px",
          left: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          // display:"flex",
          fontSize:"12px",
          textTransform:"uppercase",
          backgroundColor: "#a495c6",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          width: "80% ",
        }}
      >
        {props.content}
      </Box>
    </Box>
  );
};

const UpperDisplaySurface = () => {
  const classes = useStyles();

  return (
    <div className="feedback-content">
       <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container>
          
        <div className="feedback-session">
      
       <div  className="row pb-4 ">
<div className="col col-lg-1 col-md-1 col-sm-2 col-12 numdata ">1</div>
<div  className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding">SESSION FEEDBACK*</div>
<div style={{textAlign:"left",marginTop:"-15px"}} className="col col-lg-7 col-md-6 col-sm-12  col-12 mt-n5" ><ReactStars {...firstExample} /></div>

    </div>
    <div className="row pb-4 ">
<div  className="col col-lg-1 col-md-1 col-sm-2 col-12 numdata">2</div>
<div  className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">DISCUSSION SUMMARY*</div>
<div style={{textAlign:"right"}} className="col col-lg-7 col-md-6 col-sm-12  col-12 " ><InputField style={{fontFamily: "Montserrat"}} fullWidth variant="outlined"  type="text"/></div>

    </div>
    <div className="row pb-4 ">
<div  className="col col-lg-1 col-md-1 col-sm-2 col-12 numdata ">3</div>
<div  className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">UPLOAD DOCUMENT</div>
<div style={{textAlign:"left"}} className="col col-lg-7 col-md-6 col-sm-12  col-12 newuserTooltip top-btn " ><Button style={{
                    backgroundColor: "#816aaf",
                    color: "#fff",
                    width: "200px",
                    fontFamily:"Montserrat"
                  }}
                  variant="outlined" >
                    CLICK TO UPLOAD</Button>
                    <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"89px",width:"auto"}}>
                    Upload Document
                  </span>
                    </div>

    </div>
    <div  className="row pb-4 ">
<div  className="col col-lg-1 col-md-1 col-sm-12 col-12 numdata ">4</div>
<div  className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">SESSION HOURS*</div>
<div style={{textAlign:"left",fontFamily: "Montserrat"}} className="col col-lg-7 col-md-6 col-sm-12  col-12 " ><InputField variant="outlined"  style={{width: "186px",fontFamily:"Montserrat"}} type="text" value="0.5 Hour"/><br/> &nbsp; &nbsp;1 Hour</div>

    </div> 
    
    <div>
    <Button className="feedback-bttn"
    //  style={{
    //                color: "#3AC2D7",
    //                    marginRight: "8px",
    //                    backgroundColor: "white",
    //                    width: "150px",
    //                    border: "1px solid #00000040",
    //                    marginTop: "20px",
    //               }}
                  variant="outlined">
                    BACK</Button>
    <Button className="feedback-bluebttn"
    //  style={{
    //                 backgroundColor: "#3AC2D7",
    //                 color: "#fff",
    //                 width: "186px",
    //                 marginTop: "20px",
    //               }}
                  variant="outlined" >
                    SAVE & SUBMIT</Button>
    </div>
   </div>
        </Grid>
      </Paper>
    </Box>
   
   
   

    </div>
  );
};

const DisplayTextSurface = (props) => {
  const classes = useStyles();
  return (
    <>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box sx={{ fontSize: "44px", color: "#3AC2D7" }}>{props.content}</Box>
      </Box>
    </>
  );
};

const MentorCard = (props) => {
  const classes = useStyles();

  return (
    <Card elevation={3} className={classes.cardroot}>
      <CardContent className={classes.cardContent}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 13%",
          }}
        >
          <img
            src={mentorimage}
            className={classes.cardImage}
            alt="mentor image"
          />
          <img
            src={orgimage}
            className={classes.cardImage}
            alt="organization image"
          />
        </Box>
        <Typography className={classes.cardText1}>MENTOR MATCH</Typography>
        <DisplayTextSurface content={"91%"} />
        <Typography className={classes.cardText2}>SHRIDHAR RAJAN</Typography>
        <Divider style={{ backgroundColor: "#4cc4d6", height: "4px" }} />
     
      </CardContent>
    </Card>
  );
};

const MentorFeedback = (props) => {
  const classes = useStyles();

  const [uncollapsedCard, setUncollapsedCard] = useState(null);

  return (
    <Box
      style={{ minHeight: "500px", paddingTop: "30px",  background:
      "linear-gradient(0deg, rgba(247,243,255,1) 0%, rgba(217,199,230,0.9082983535210959) 100%)", paddingBottom: "30px" }}
    >
      <Typography className={classes.firstHeading}>
        NATIONAL MENTORSHIP PORTAL
      </Typography>
      <Typography className={classes.secondHeading}>
        SESSION MoM
      </Typography>

      <UpperDisplaySurface />

     
    </Box>
  );
};

export default MentorFeedback;